module.exports = __webpack_public_path__ + "media/bol/bghead-55a1181c.png";